import styled, { keyframes, css } from 'styled-components';
import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { variant } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
var sizeStyles = variant({
  prop: "size",
  variants: {
    xs: {
      width: "12px",
      height: "12px"
    },
    sm: {
      width: "18px",
      height: "18px"
    },
    md: {
      width: "30px",
      height: "30px"
    },
    lg: {
      width: "42px",
      height: "42px"
    }
  }
});
var spinKeyframes = keyframes(["100%{transform:rotate(630deg);}"]);
var dashLinekeyframes = keyframes(["0%{stroke-dasharray:1px,200px;stroke-dashoffset:0px;}50%{stroke-dasharray:100px,200px;stroke-dashoffset:-15px;}100%{stroke-dasharray:100px,200px;stroke-dashoffset:-125px}"]);
var spinAnimation = css(["animation:", " 1.4s linear 0s infinite;"], spinKeyframes);
var dashLineCircleAnimation = css(["stroke-dasharray:80px,200px;stroke-dashoffset:0px;animation:", " 1.4s ease-in-out 0s infinite;"], dashLinekeyframes);
var ProgressWrapper = styled.svg.withConfig({
  componentId: "sc-1fdnysn-0"
})(["transform:rotate(270deg);", ";", ""], function (_ref) {
  var size = _ref.size;
  return typeof size === "number" ? css(["width:", "px;height:", "px;"], size, size) : sizeStyles;
}, function (_ref2) {
  var progress = _ref2.progress;
  return progress === "indeterminate" && spinAnimation;
});
var BackCircle = styled.circle.withConfig({
  componentId: "sc-1fdnysn-1"
})(["opacity:0.24;"]);
var ProgressCircle = styled.circle.withConfig({
  componentId: "sc-1fdnysn-2"
})(["", ";"], function (_ref3) {
  var progress = _ref3.progress,
      transitionDelay = _ref3.transitionDelay;
  return progress === "indeterminate" ? dashLineCircleAnimation : css(["transition:stroke-dashoffset ", "ms ease-in-out;"], transitionDelay);
});
export { BackCircle, ProgressCircle, ProgressWrapper };